import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import crmEn from '../../../frontend/src/i18n/locales/en/translation.json';
import crmEs from '../../../frontend/src/i18n/locales/es/translation.json';
import crmPt from '../../../frontend/src/i18n/locales/pt/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import pt from './locales/pt/translation.json';
import { legalEn, legalEs, legalPt } from './legalContent';

const savedLang = localStorage.getItem('crm-lang') || 'es';

function mergeTranslations(base, overlay) {
  const out = { ...base };
  for (const [key, value] of Object.entries(overlay)) {
    const existing = out[key];
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      existing &&
      typeof existing === 'object' &&
      !Array.isArray(existing)
    ) {
      out[key] = mergeTranslations(existing, value);
    } else {
      out[key] = value;
    }
  }
  return out;
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...mergeTranslations(crmEn, en), legal: legalEn } },
    es: { translation: { ...mergeTranslations(crmEs, es), legal: legalEs } },
    pt: { translation: { ...mergeTranslations(crmPt, pt), legal: legalPt } }
  },
  lng: savedLang,
  fallbackLng: 'en',
  supportedLngs: ['es', 'en', 'pt'],
  interpolation: { escapeValue: false }
});

export default i18n;
